import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  loadDropdownDataRequest: [''],
  loadDropdownDataSuccess: ['dropdownDetails'],
  loadDropdownDataFailure: ['error'],

  submitContactRequest: ['payload'],
  submitContactSuccess: ['contactUsDetails'],
  submitContactFailure: ['error'],
});

const contactUsActions = {
  Types,
  Creators,
};

export default contactUsActions;
